<template>
  <div class="left-nav-box">
    <ul>
      <div  v-for="(item, index) in navList"  :key="index">
        <div class="titcode">{{item.code}}</div>
        <li
          v-for="(citem, cidx) in item.child"  :key="cidx"
          :class="[code === citem.code ? 'active' : '']"
          @click="handleTabPage(citem.code)"
        >
          {{ citem.name }}
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NavTab',
  props: ['code', 'navList'],
  methods: {
    // 菜单切换
    handleTabPage (code) {
      this.$emit('handleTabPage', code)
    }
  }
}
</script>

<style lang="scss">
.left-nav-box {
  height: 760px;
  // z-index: 1;
  position: relative;
  min-width: 200px;
  // z-index: 99;
  background-color: #fff;
  box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
  border-radius: 8px;
  ul {
    position: absolute;
    padding: 0 40px 28px;
    .titcode {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 26px;
      margin-bottom: 20px;
      color: #424855;
      margin-top: 28px;
      opacity: 1;
    }
    li {
      position: relative;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      margin-bottom: 16px;
      color: #424855;
      transition: 0.2s all linear;
      cursor: pointer;
      &::before {
         color: #9b232a;
      }
     &:hover {
        color: #9b232a;
      }
      &:active {
        color: #9b232a;
      }
      &.active {
        color: #9b232a;
      }
    }
  }
}
</style>
